import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import ImageZoom from '../../components/master/ImageZoom';
import Modal from '../../components/master/Modal';
import { getQueryString, hardCopy, pexios, uploadImages } from '../../utils/functions';
import { history, latinAlphabet, url } from '../../utils/variables';
import ShowPlate from '../expert/ShowPlate';
import addImage from '../../assets/images/AddImagePlaceholder/addImage.png';
import CarInfoIcon from '../../assets/images/icons/car-info-orange.png';
import InsuranceInfoIcon from '../../assets/images/icons/insurance-info-orange.png';
import GetLocation from './GetLocation';
import { TitleContext } from '../../App';
import HeaderIcon from '../../assets/images/header-icon/report-info.png'
import defaultProfile from '../../assets/images/user-icon.png'
import moment from 'moment-jalaali';

function AccidentReport() {
    const { t } = useTranslation();
    const {id,state} = useSelector(store => store.routerData);
    // const fileState = getQueryString('state') || '';
    // const id = selector?.id;
    // const {id} = useSelector((store) => store.routerData);
    // const { t } = useTranslation();
    const [loader,setLoader] = useState(false);
    // const [report, setReport] = useState([]);
    const [accident,setAccident] = useState({
        // id : id,
        // address : '',
        // lat: '',
        // lng: '',
        // insurance_type: '',
        // city_id: '',
        // state_id: '',
    })
    // const [culprit,setCulprit] = useState({
    //     car:{
    //         title: '',
    //         plate_iran: null,
    //         plate_left: null,
    //         plate_center: null,
    //         plate_right: null,
    //     },
    //     third: {
    //         insurance_number: null,
    //         insurance_company: null,
    //         insurance_start_date :null,
    //         insurance_expire_date:null,
    //     },
    //     body : {
    //         insurance_number: null,
    //         insurance_company: null,
    //         insurance_start_date: null,
    //         insurance_expire_date:null
    //     },
    // })
    const [losses,setLosses] = useState([])
    const [expert,setExpert] = useState(null)
    const [insurance,setInsurance] = useState(null)
    // const [losses,setLosses] = useState({
    //     car:{
    //         title: '',
    //         plate_iran: null,
    //         plate_left: null,
    //         plate_center: null,
    //         plate_right: null,
    //     },
    //     third: {
    //         insurance_number: null,
    //         insurance_company: null,
    //         insurance_start_date :null,
    //         insurance_expire_date:null,
    //     },
    //     body : {
    //         insurance_number: null,
    //         insurance_company: null,
    //         insurance_start_date: null,
    //         insurance_expire_date:null
    //     },
    // })
    // const [attachments, setAttachments] = useState([]);
    // const [imgUid, setImgUid] = useState(null);
    // const userType = getQueryString('user') || 'culprit';
    // const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    // const {title ,setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle('اطلاعات تصادف')
    // },[title])

    // useEffect(() => {
    //     setLoader(true)
    //     pexios('api/v2/get_report_by_id', 'post', { id })
    //         .then(res => {
    //             const report = res.data.data;
    //             setReport(report);
    //             setLoader(false)
    //         })
    // }, [id]);
    useEffect(()=>{
        setLoader(true)
        if(state && state === 1){
            history.push(`/user-images`);
            return;
        }
        pexios(`api/get_user_accident/${id}`)
        .then((res)=>{
            const res_accident = res.data.data
            if(res_accident.status === 2 ) {
                res_accident.insurance_type === 'third' ?
                history.push(`/losses-info`)
                :
                history.push(`/get_location`)
            }
            // setAccident({
            //     ...accident,
            //     ...res_accident,
            // })
            setAccident(res_accident)
            // setCulprit({...culprit,...res_accident.culprit})
            setLosses(res_accident.losses)
            setExpert(res_accident.expert)
            setInsurance(res_accident.pay_branch)
            setLoader(false)
        })
    },[id])
    // useEffect(() => {
    //     pexios('api/v2/get_insurance')
    //         .then(res => {
    //             setInsuranceCompanies(res.data.data);
    //         });
    // }, []);
    // useEffect(() => {
    //     if (!report.id) return;
    //     setAttachments([...report.attachments, ...report.accident.attachments]);
    // }, [report]);
    // const images = attachments.filter(img=>img.filename.includes('cul_crash_image'));
    // function addLosses() {
    //     history.push(`/losses-info`);
    //     // history.push(`/user-info?user=losses`);
    // }
    // function selectExpert () {
    //     history.push('/select-expert');
    // }
    // function finishUpload(image, name, done) {
    //     uploadImages({
    //         id: accident.id,
    //         type: 'accident',
    //         //name: `${user.type === 'expert' ? name : `crash_image${extraImagesCount}`}`,
    //         name :name,
    //         image,
    //         done,
    //         callback: (data) => {
    //             setAttachments(prevState => ([
    //                 ...prevState,
    //                 data,
    //             ]));
    //         },
    //     });
    // }
  return (
    <div className='content report report-complete'>
        {loader ?
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
        :
        <>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <div className='information br10 p10'>
            <div className='d-flex space-between align-items-center'>
            {accident?.insurance_id &&<div className='accident-insurance-logo'> <img alt="logo" src={`${url}/images/insurances/${accident?.insurance_id}.png`}/></div>}
            <div className='d-flex flex-column'>
                <p>
                    <span className='item'>شناسه پرونده : </span>
                    <span style={{color: '#f6945a'}}>{accident?.id}</span>
                </p>
                <p>
                    <span className='item'>بیمه نامه پرونده : </span>
                    <span>{accident?.insurance_type === 'body' ? 'بدنه' : 'شخص ثالث'} {accident?.insurance_company}</span>
                </p>
            </div>
            </div>
        </div>
        {accident.status_content &&
        <div className='information br10 p10 state-box'>
            <p className='text-center'>{accident.status_content}</p>
        </div>
        }
        {insurance &&
        <div className='information br10 p10'>
            <p>
                <span className='item'>شعبه پرداخت بیمه گر : </span>
                <span>{insurance.title}</span>
            </p>
            <p>
                <span className='item'>آدرس : </span>
                <span>{insurance.address}</span>
            </p>
            <p>
                <span className='item'>شماره تماس : </span>
                <span>{insurance.tell}</span>
            </p>
        </div>
        }
        <div className='information br10 p10'>
            <p>
                <span className='item'>{accident?.insurance_type === 'body' ? 'درخواست کننده' : 'مقصر'} : </span>
                <span>{accident?.culprit?.user_full_name}</span>
            </p>
            <p>
                <span className='item'>خودرو {accident?.insurance_type === 'body' ? '' : 'مقصر'} : </span>
                <span>{accident?.culprit?.car?.title}</span>
            </p>
        </div>
        {losses.length > 0 &&
        <div className='information br10 p10'>
            {losses.map((l,index)=>(
                <>
                <p>
                <span className='item'>زیان دیده {t(latinAlphabet[index])} : </span>
                <span>{l?.full_name}</span>
                </p>
                <p>
                    <span className='item'>خودرو زیان دیده : </span>
                    <span>{l?.car?.title}</span>
                </p>
                </>
            ))}
        </div>
        }
        <div className='information br10 p10'>
            <p>
                <span className='item'>زمان اعلام خسارت : </span>
                <span>{moment(accident.created_at).format('HH:mm jYYYY/jM/jD')}</span>
            </p>
            {accident.expert_time &&
            <p>
                <span className='item'>زمان کارشناسی : </span>
                <span>{moment(accident.expert_time).format('HH:mm jYYYY/jM/jD')}</span>
            </p>
            }
        </div>
        {expert &&
        <div className='information br10 p10'>
            <div className='d-flex space-between align-items-center'>
            <img
                className='expert-avatar'
                src={
                    accident?.expert?.avatar ?
                        `${url}/files?uid=${accident?.expert?.avatar.uid}` :
                        defaultProfile
                }
                alt="logo"/>
            <div className='d-flex flex-column'>
                <p>
                    <span className='item'>کارشناس پرونده : </span>
                    <span>{expert?.full_name ||'مشخص نشده'}</span>
                </p>
                <p>
                    <span className='item'>شماره تماس کارشناس : </span>
                    <span>{expert?.mobile ||'مشخص نشده'}</span>
                </p>
            </div>
            </div>
        </div>
        }
        {/* <p className='title m10'><div className='pl10'>خودرو مقصر</div><span className='line'/></p> */}
        {/* <div className='plate-container'>
            <ShowPlate
                plate={{
                    plate_iran: culprit.car.plate_iran,
                    plate_left: culprit.car.plate_left,
                    plate_center: culprit.car.plate_center,
                    plate_right: culprit.car.plate_right,
                    plate_type: culprit.car.plate_type
                }}
            />
        </div>
        <div className='information br10 p10'>
            <div className='d-flex align-items-center m10'>
                <p className='rtl'>{culprit.car.title}</p>
                <img className='ml10' src={CarInfoIcon}/>
            </div>
            {accident.insurance_type === 'third' && 
            <div className='d-flex align-items-center m10'>
                <p>{insuranceCompanies[culprit.third.insurance_company-1]?.title} - {culprit.third.insurance_number}</p>
                <img className='ml10' src={InsuranceInfoIcon}/>
            </div>
            }
            {
            //culprit.body.insurance_company &&
                accident.insurance_type === 'body' &&
                <div className='d-flex align-items-center m10'>
                    <p>{insuranceCompanies[culprit.body.insurance_company-1]?.title} - {culprit.body.insurance_number}</p>
                    <img className='ml10' src={InsuranceInfoIcon}/>
                </div>
            }
        </div>
        {losses.length > 0 && losses.map((loss,index)=>( 
        <>
         <p className='title m10'><div className='pl10'>{`خودرو ${t('Losses')} ${t(latinAlphabet[index])}`}</div><span className='line'/></p>
        <div className='plate-container'>
            <ShowPlate
                plate={{
                    plate_iran: loss.car.plate_iran,
                    plate_left: loss.car.plate_left,
                    plate_center: loss.car.plate_center,
                    plate_right: loss.car.plate_right,
                    plate_type: loss.car.plate_type
                }}
            />
        </div>
        <div className='information br10 p10'>
            <div className='d-flex align-items-center m10'>
                <p className='rtl ml10'>{loss.car.title}</p>
                <img className='ml10' src={CarInfoIcon}/>
            </div>
            <div className='d-flex align-items-center m10'>
                <p>{insuranceCompanies[loss.third.insurance_company-1]?.title} - {loss.third.insurance_number}</p>
                <img className='ml10' src={InsuranceInfoIcon}/>
            </div>
        </div>
        </>))} */}
        {/* <p className='title m10'><div className='pl10'>نقشه</div><span className='line'/></p>
        <GetLocation type='free' accidentLocation={{lat:accident.lat,lng:accident.lng}} fixedData={(state && state > 3) ? true : false}/>
        <p className='title m10'><div className='pl10'>تصاویر حادثه</div><span className='line'/></p> */}

        {/* <div className='box'>
        <div className='imageBox rtl'>
        {images.map(img=>(
            <div className='imageParent register-image-parent' key={img.id}>
                <img
                    onClick={() => setImgUid(img.uid)}
                    src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                    alt='img'
                    id={img.id}
                />
            </div>
        ))}
        <div className='imageParent register-image-parent'>
                    <ImagePickerModal
                        renderBtn={<div className='add-image'><img src={addImage} alt='img'/></div>}
                        upload={(image, done) => finishUpload(image,`cul_crash_image_${images.length +1}`, done)}
                    />
                </div>
        </div>
        </div> */}
            <div className='group-btn mt60'>
                <button 
                    className='btn btn-circle btn-block btn-orange w-50'
                    onClick={()=> history.push('/report-list')}
                    >بازگشت به لیست 
                </button>
                {accident.sign_link &&
                <a 
                    className='btn btn-circle btn-block btn-white-purple w-50'
                    href={accident.sign_link}
                    target="_blank" 
                    rel="noreferrer">
                    تایید کارشناسی
                </a>
                }
                {state && state < 5 &&
                <button 
                    className='btn btn-circle btn-block btn-white-purple w-50'
                    onClick={()=>history.push(`/images-complement?losses_count=${losses.length}`)}>
                    تکمیل تصاویر
                </button>
                }
            </div> 
        </>
        }
    </div>
  )
}

export default AccidentReport;